var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PATTERN-LIBRARY",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PT---Indicators",
    transform: "translate(-800.000000, -390.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mt/molecules/progress-status/error",
    transform: "translate(790.000000, 380.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a/icons/20/exclamation",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 2,
    x2: 10,
    y2: 13,
    id: "Line",
    stroke: "currentColor",
    strokeWidth: 1.66,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    cx: 10,
    cy: 17,
    r: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.55b9a78d523540a8d9494535701b1c76.svg";
export { ForwardRef as ReactComponent };